"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _wrapper = require("@uniqore/wrapper");

var _Image = _interopRequireDefault(require("../Image"));

var _material = require("@mui/material");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const ImageContainer = (0, _material.styled)(_wrapper.UqBox)(props => ({
  height: 1,
  minHeight: '40vh',
  [props.theme.breakpoints.up('sm')]: {
    minHeight: 240
  },
  [props.theme.breakpoints.up('lg')]: {
    minHeight: 320
  }
}));

const CarouselItem = props => {
  return _react.default.createElement(_wrapper.UqGrid, {
    container: true,
    direction: "column",
    flexWrap: "nowrap",
    justifyContent: "flex-end"
  }, _react.default.createElement(ImageContainer, {
    item: true,
    xs: 12,
    alignSelf: "center",
    container: true,
    justifyContent: "center",
    alignItems: "center"
  }, props.image && _react.default.createElement(_Image.default, _extends({}, props.image, {
    style: {
      maxWidth: 'calc(100% - 32px)',
      maxHeight: '100%'
    }
  }))), _react.default.createElement(_wrapper.UqBox, {
    item: true,
    xs: 12,
    style: {
      marginTop: 16,
      marginBottom: 16
    },
    justifyContent: "center"
  }, typeof props.headline === 'string' ? _react.default.createElement(_wrapper.UqTypography, {
    textAlign: "center",
    variant: "h6"
  }, props.headline) : props.headline, typeof props.subtitle === 'string' ? _react.default.createElement(_wrapper.UqTypography, {
    textAlign: "center",
    color: "text.secondary",
    variant: "subtitle1"
  }, props.subtitle) : props.subtitle));
};

exports.CarouselItem = CarouselItem;